"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Form = require("./components/Form");

var _Form2 = _interopRequireDefault(_Form);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Form2.default;


//////////////////
// WEBPACK FOOTER
// ./~/react-jsonschema-form/lib/index.js
// module id = 971
// module chunks = 0